import lodash from 'lodash';

export function applyCombineReducersByKey(reducer, keyPath = 'payload.id') {
    return function reducerByKey(state, action) {
        const key = lodash.get(action, keyPath);
        if (lodash.isNil(key)) {
            return state;
        }
        return {
            ...state,
            [key]: reducer(state[key], action)
        };
    };
}

export function applyCombineReducersByIndex(reducer, indexPath = 'payload.index') {
    return function reducerByKey(state, action) {
        const index = lodash.get(action, indexPath);
        if (lodash.isNil(index)) {
            return state;
        }
        const updatedArray = [...state];
        if(!lodash.isNil(state[index])) {
            lodash.set(updatedArray, index, reducer(state[index], action));
        }
        return updatedArray;
    };
}